// export const API_HOST = "http://localhost:3001/api/v1/";
// export const API_HOST = "https://fdf4-2401-4900-8fe5-a881-2e94-29c9-b4b6-2634.ngrok-free.app/api/v1/";

// export const API_HOST = "https://smartcheck.toothlens.com/api/v1/";

// export const API_HOST = "https://devhygiene.toothlens.com/api/v1/";

export const API_HOST = "https://selfcheck.toothlens.com/api/v1/";

// export const API_HOST = "https://devtesting.toothlens.com/api/v1/";